import { normalize } from 'normalizr'
import { Schemas } from '@redux/schema'
import { updateEntities } from '@redux/entities'

import api from '@functions/api'

import { handleError } from '../utils'

const FETCH_REQUEST = 'contenthouse/serviceJob/FETCH_REQUEST'
const FETCH_SUCCESS = 'contenthouse/serviceJob/FETCH_SUCCESS'
const FETCH_FAILURE = 'contenthouse/serviceJob/FETCH_FAILURE'

const CREATE_REQUEST = 'contenthouse/serviceJob/CREATE_REQUEST'
const CREATE_SUCCESS = 'contenthouse/serviceJob/CREATE_SUCCESS'
const CREATE_FAILURE = 'contenthouse/serviceJob/CREATE_FAILURE'

const UPDATE_REQUEST = 'contenthouse/serviceJob/UPDATE_REQUEST'
const UPDATE_SUCCESS = 'contenthouse/serviceJob/UPDATE_SUCCESS'
const UPDATE_FAILURE = 'contenthouse/serviceJob/UPDATE_FAILURE'

// Initial State
const initialState = {
  creating: false,
  deleting: false,
  errors: [],
  loaded: false,
  loadedIds: [],
  loadedForKeys: [],
  loading: false,
  results: {},
  updating: false,
}

// Actions
export function fetchRequest(payload = {}){
  return {
    type: FETCH_REQUEST,
    loadedForKeys: payload.loadedForKeys,
    loadedIds: payload.loadedIds,
  }
}

export function fetchSuccess(payload = {}){
  return {
    type: FETCH_SUCCESS,
    results: payload.data,
  }
}

export function fetchFailure(errors = []){
  return {
    type: FETCH_FAILURE,
    errors,
  }
}

export function createRequest(){
  return {
    type: CREATE_REQUEST,
  }
}

export function createSuccess(){
  return {
    type: CREATE_SUCCESS,
  }
}

export function createFailure(errors = []){
  return {
    type: CREATE_FAILURE,
    errors,
  }
}

export function updateRequest(){
  return {
    type: UPDATE_REQUEST,
  }
}

export function updateSuccess(){
  return {
    type: UPDATE_SUCCESS,
  }
}

export function updateFailure(errors = []){
  return {
    type: UPDATE_FAILURE,
    errors,
  }
}

export function loadServiceJobsV2(options){
  const { entityKey } = options || {}

  return (dispatch, getState) => {
    const loadedForKeys = [...getState().serviceJobs.loadedForKeys]
    if (entityKey && !loadedForKeys.includes(entityKey)){
      loadedForKeys.push(entityKey)
    }

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/v2/service-jobs/', options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export function loadServiceJobs(options){
  const { entityKey } = options || {}

  return (dispatch, getState) => {
    const loadedForKeys = [...getState().serviceJobs.loadedForKeys]
    if (entityKey && !loadedForKeys.includes(entityKey)){
      loadedForKeys.push(entityKey)
    }

    dispatch(fetchRequest({ loadedForKeys }))

    const promise = api('/v1/service-jobs', options)
      .then((data) => {
        const payload = {
          data: data.data,
          // additionalInfo: JSON.parse(data.headers['x-additional-info']),
        }

        const normalizedJson = normalize(data.data, Schemas.SERVICE_JOB_ARRAY)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess(payload))

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function loadRelatedServiceJobs(id, dispatch){
  const options = {
    campaigns: id.toString(),
    includes: 'campaign,client,details,service,status,users,notes,postProductionChecklistItems',
  }

  dispatch(fetchRequest())
  const promise = api('/v1/service-jobs', options)
    .then(({ data }) => {
      const payload = {
        data,
        // additionalInfo: JSON.parse(data.headers['x-additional-info']),
      }
      const normalizedJson = normalize(data, Schemas.SERVICE_JOB_ARRAY)
      dispatch(updateEntities(normalizedJson))
      dispatch(fetchSuccess(payload))

      return { success: true, data }
    })
    .catch((data) => {
      const errors = handleError(data)
      dispatch(fetchFailure(errors))

      return { success: false, errors }
    })
  return promise
}

export function loadServiceJobV1(serviceJobId, options){
  return (dispatch, getState) => {
    const state = getState()
    const loadedIds = [...state.serviceJobs.loadedIds]

    if (serviceJobId && !loadedIds.includes(serviceJobId)){
      loadedIds.push(serviceJobId)
    }

    dispatch(fetchRequest({ loadedIds }))

    const promise = api(`/v1/service-jobs/${serviceJobId}`, options)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB)
        dispatch(updateEntities(normalizedJson))
        dispatch(fetchSuccess())

        return loadRelatedServiceJobs(data.campaign.id, dispatch)
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(fetchFailure(errors))

        return { success: false, result: errors }
      })

    return promise
  }
}

export function createInitialCopyAsset(serviceJob, options){
  const config = {
    method: 'POST',
    data: serviceJob,
  }

  return (dispatch) => {
    dispatch(createRequest())

    const promise = api(`/v1/service-jobs/${serviceJob.id}/initial-copy-assets`, options, config)
      .then(() => {
        dispatch(createSuccess())
        return { success: true, data: {} }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(createFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export function assignServiceJobStatus(serviceJob, options, serviceJobOptions){
  const config = {
    method: 'POST',
    data: serviceJob,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/service-jobs/${serviceJob.id}/workflow`, { ...options, includes: serviceJobOptions.includes }, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export function updateServiceJobTotalAssets(serviceJob, options, serviceJobOptions){
  const config = {
    method: 'PUT',
    data: options,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/service-jobs/${serviceJob.id}/totalAssets`, { ...options, includes: serviceJobOptions.includes }, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })
    return promise
  }
}

export function updateServiceJob(serviceJob, options, serviceJobOptions){
  const config = {
    method: 'PUT',
    data: serviceJob,
  }

  return (dispatch) => {
    dispatch(updateRequest())

    const promise = api(`/v1/service-jobs/${serviceJob.id}`, { ...options, includes: serviceJobOptions.includes }, config)
      .then(({ data }) => {
        const normalizedJson = normalize(data, Schemas.SERVICE_JOB)
        dispatch(updateEntities(normalizedJson))
        dispatch(updateSuccess())

        return { success: true, data }
      })
      .catch((data) => {
        const errors = handleError(data)
        dispatch(updateFailure(errors))

        return { success: false, errors }
      })

    return promise
  }
}

export default function reducer(state = initialState, action = {}){
  const { type, errors, loadedForKeys, loadedIds, results } = action

  switch (type){
    case FETCH_REQUEST:
      return {
        ...state,
        loadedForKeys: loadedForKeys || state.loadedForKeys,
        loadedIds: loadedIds || state.loadedIds,
        loading: true,
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        errors: [],
        loaded: true,
        loading: false,
        results: results || state.results,
      }
    case FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: false,
        errors,
      }
    case CREATE_REQUEST:
      return {
        ...state,
        creating: true,
      }
    case CREATE_SUCCESS:
      return {
        ...state,
        creating: false,
        errors: [],
      }
    case CREATE_FAILURE:
      return {
        ...state,
        creating: false,
        errors: action.errors,
      }
    case UPDATE_REQUEST:
      return {
        ...state,
        updating: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        updating: false,
        errors: [],
      }
    case UPDATE_FAILURE:
      return {
        ...state,
        updating: false,
        errors,
      }
    default:
      return state
  }
}
